// Standard Thoroughbred saddle-cloth colors (post positions 1-15)
// These are the conventional colors used on US racing programs.
export const SADDLE_COLORS = {
  1:  { bg: "#dc2626", fg: "#ffffff", border: "#7f1d1d" }, // red / white
  2:  { bg: "#ffffff", fg: "#000000", border: "#000000" }, // white / black
  3:  { bg: "#1d4ed8", fg: "#ffffff", border: "#0c1f6b" }, // blue / white
  4:  { bg: "#fde047", fg: "#000000", border: "#854d0e" }, // yellow / black
  5:  { bg: "#15803d", fg: "#ffffff", border: "#0a3d1d" }, // green / white
  6:  { bg: "#0a0a0a", fg: "#fde047", border: "#000000" }, // black / yellow
  7:  { bg: "#f59e0b", fg: "#000000", border: "#7c4a03" }, // orange / black
  8:  { bg: "#c084fc", fg: "#000000", border: "#6b21a8" }, // mauve / black
  9:  { bg: "#7dd3fc", fg: "#000000", border: "#075985" }, // turquoise / black
  10: { bg: "#7c3aed", fg: "#ffffff", border: "#3b0764" }, // purple / white
  11: { bg: "#9ca3af", fg: "#dc2626", border: "#374151" }, // grey / red
  12: { bg: "#84cc16", fg: "#0a0a0a", border: "#3f6212" }, // lime / black
  13: { bg: "#78350f", fg: "#fde047", border: "#431407" }, // brown / yellow
  14: { bg: "#9f1239", fg: "#ffffff", border: "#4c0519" }, // maroon / white
  15: { bg: "#c2410c", fg: "#000000", border: "#7c2d12" }, // rust / black
};

export const colorFor = (n) =>
  SADDLE_COLORS[Number(n)] || { bg: "#e5e7eb", fg: "#0a0a0a", border: "#6b7280" };
